module.exports = __webpack_public_path__ + "img/rate_heart.7969a3cf.svg";